import { Component } from '@angular/core';

@Component({
  selector: 'zui-four-oh-four',
  templateUrl: './four-oh-four.component.html',
  styleUrls: ['./four-oh-four.component.scss']
})
export class FourOhFourComponent {
  // TODO: When mocks exist, modify wording/style to match style guide.
  public readonly heading = '404 - Page Not Found';
  public readonly message = "Oops, something went wrong. We can't seem to find the page you are looking for.";

  constructor() {}
}
